import { getLogger, type GqlExecutor } from '@hopdrive/sdk-core'
import { insertEventlog } from '@gql/operations'
import type { Eventlog, EventlogInsertInput } from '../../types'

export async function createEvent(
  eventlog: EventlogInsertInput,
  executor?: GqlExecutor
): Promise<Eventlog> {
  const inserted = await insertEventlog({ eventlog } as any, { executor })

  if (!inserted) {
    throw new Error('Failed to insert eventlog')
  }

  getLogger().debug('event.created', {
    id: inserted.id,
    actiontype_id: inserted.actiontype_id,
    user: inserted.user,
  })

  return inserted as Eventlog
}
